<template>
  <q-icon size="20px">
    <svg class="custom-icon" viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg" width="22" height="21">
      <path d="M11.964 4.3125H10.4746V5.75H11.964V4.3125Z" />
      <path d="M11.2186 0C5.48452 0 0.792969 4.52813 0.792969 10.0625C0.792969 15.5969 5.48452 20.125 11.2186 20.125C16.9528 20.125 21.6443 15.5969 21.6443 10.0625C21.6443 4.52813 16.9528 0 11.2186 0ZM11.2186 18.6875C6.30368 18.6875 2.28235 14.8062 2.28235 10.0625C2.28235 5.31875 6.30368 1.4375 11.2186 1.4375C16.1336 1.4375 20.1549 5.31875 20.1549 10.0625C20.1549 14.8062 16.1336 18.6875 11.2186 18.6875Z" />
      <path d="M11.964 7.1875H10.4746V15.8125H11.964V7.1875Z" />
    </svg>
  </q-icon>
</template>

<script>
export default {
  name: 'InfoIcon'
}
</script>

<style scoped>

</style>
